function asyncGeneratorStep(gen, resolve, reject, _next, _throw, key, arg) { try { var info = gen[key](arg); var value = info.value; } catch (error) { reject(error); return; } if (info.done) { resolve(value); } else { Promise.resolve(value).then(_next, _throw); } }

function _asyncToGenerator(fn) { return function () { var self = this, args = arguments; return new Promise(function (resolve, reject) { var gen = fn.apply(self, args); function _next(value) { asyncGeneratorStep(gen, resolve, reject, _next, _throw, "next", value); } function _throw(err) { asyncGeneratorStep(gen, resolve, reject, _next, _throw, "throw", err); } _next(undefined); }); }; }

/*
 * @copyright Copyright (c) 2021 Jonas Heinrich <onny@project-insanity.org>
 *
 * @author Jonas Heinrich <onny@project-insanity.org>
 *
 * @license GNU AGPL version 3 or any later version
 *
 * This program is free software: you can redistribute it and/or modify
 * it under the terms of the GNU Affero General Public License as
 * published by the Free Software Foundation, either version 3 of the
 * License, or (at your option) any later version.
 *
 * This program is distributed in the hope that it will be useful,
 * but WITHOUT ANY WARRANTY; without even the implied warranty of
 * MERCHANTABILITY or FITNESS FOR A PARTICULAR PURPOSE. See the
 * GNU Affero General Public License for more details.
 *
 * You should have received a copy of the GNU Affero General Public License
 * along with this program. If not, see <http://www.gnu.org/licenses/>.
 *
 */
import { RadioApi } from './../services/RadioApi';
var apiClient = new RadioApi();
export default {
  state: {
    favorites: []
  },
  getters: {
    favorites: function favorites(state) {
      return state.favorites;
    },
    isFavorite: function isFavorite(state) {
      return function (station) {
        if (station !== undefined) {
          var index = state.favorites.findIndex(function (_station) {
            return _station.stationuuid === station.stationuuid;
          });

          if (index !== -1) {
            return true;
          }
        }

        return false;
      };
    }
  },
  mutations: {
    addFavorite: function addFavorite(state, station) {
      state.favorites.push(station);
    },
    removeFavorite: function removeFavorite(state, station) {
      var existingIndex = state.favorites.findIndex(function (_station) {
        return _station.id === station.id;
      });

      if (existingIndex !== -1) {
        state.favorites.splice(existingIndex, 1);
      }
    },
    setFavorites: function setFavorites(state, stations) {
      state.favorites = stations;
    }
  },
  actions: {
    loadFavorites: function loadFavorites(_ref) {
      return _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee() {
        var commit, stations;
        return regeneratorRuntime.wrap(function _callee$(_context) {
          while (1) {
            switch (_context.prev = _context.next) {
              case 0:
                commit = _ref.commit;
                _context.next = 3;
                return apiClient.loadFavorites();

              case 3:
                stations = _context.sent;
                commit('setFavorites', stations);

              case 5:
              case "end":
                return _context.stop();
            }
          }
        }, _callee);
      }))();
    },
    addFavorite: function addFavorite(_ref2, station) {
      var commit = _ref2.commit;
      apiClient.addFavorite(station).then(function (station) {
        commit('addFavorite', station);
      });
    },
    removeFavorite: function removeFavorite(_ref3, station) {
      var commit = _ref3.commit;
      apiClient.removeFavorite(station).then(function (station) {
        commit('removeFavorite', station);
      });
    }
  }
};